import { LinkCard, LinkCardGrid } from '../../components/LinkCard';
import { Markdown } from '../../components/Markdown';
import { useLocale } from '../../lib/locale';
import type { CatalogEntry } from './stories';

/** One card per story, each onto its page. */
export function StoryCards({ entries }: { entries: CatalogEntry[] }) {
  const { locale } = useLocale();
  return (
    <LinkCardGrid>
      {entries.map(({ slug, story }) => (
        <LinkCard
          key={slug}
          to={`/library/${slug}`}
          title={story.title[locale]}
        >
          <Markdown>{story.description[locale]}</Markdown>
        </LinkCard>
      ))}
    </LinkCardGrid>
  );
}
